// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D8pa","top":"styles_top__1cDA1","left":"styles_left__3TD7i","description":"styles_description__1Jk6a"};